import { Role } from 'constants/roles';

import { useMemo } from 'react';

import { usePermissions } from 'hooks/usePermissions';

export function useCommissionsShow() {
  const { roles } = usePermissions();

  const isCommissionsShow = useMemo(() => {
    return (
      roles.includes(Role.Admin) ||
      roles.includes(Role.Tech) ||
      roles.includes(Role.Payment) ||
      roles.includes(Role.Finance) ||
      roles.includes(Role.FinanceLead)
    );
  }, [roles]);

  return { isCommissionsShow };
}
